// PrintFallback — a hidden-on-screen, print-only text container.
// Lives inside the React tree at the top of <App /> so search engines and
// assistive tech that ignore the WebGL canvas can still see the site's
// content. The CSS rule for `.print-fallback` keeps it `display: none`
// on screen; @media print reveals it as a black-on-white serif view of
// the same data as the planet scene.

import {
  CONTACT,
  HUD_PANELS,
  NOTES,
  SATELLITES,
  TIMELINE_MILESTONES,
} from './planet/planetSections';

export function PrintFallback() {
  return (
    <div className="print-fallback" aria-hidden="false">
      <section className="print-section">
        <h1>hello<br />yhazrin</h1>
        <p>{HUD_PANELS.intro.byline}</p>
        <p className="meta">Est. 2019 · Kuala Lumpur</p>
      </section>

      <section className="print-section" id="print-about">
        <h2>About</h2>
        <p className="eyebrow">A small house on the planet</p>
        <p>
          <strong>{HUD_PANELS.about.name}</strong> — {HUD_PANELS.about.role}
        </p>
        <p>{HUD_PANELS.about.bio}</p>
        <p className="meta">
          {HUD_PANELS.about.meta.location} ·{' '}
          {HUD_PANELS.about.meta.stack} ·{' '}
          {HUD_PANELS.about.meta.since}
        </p>
      </section>

      <section className="print-section" id="print-skills">
        <h2>Skills</h2>
        <p className="eyebrow">Standing stones rise from the terrain</p>
        {HUD_PANELS.skills.categories.map((c) => (
          <div key={c.name}>
            <h3>{c.name}</h3>
            <p>{c.items.join(' · ')}</p>
          </div>
        ))}
      </section>

      <section className="print-section" id="print-projects">
        <h2>Projects</h2>
        <p className="eyebrow">Things I've shipped</p>
        {SATELLITES.map((s) => (
          <div key={s.id} className="item">
            <h3>
              <span className="year">{s.year}</span> {s.name}
            </h3>
            <p>{s.blurb}</p>
            <p className="meta">{s.tech.join(' · ')}</p>
            {s.links && s.links.length > 0 && (
              <p className="meta">
                {s.links
                  .map((l, i) => (
                    <span key={l.url}>
                      {i > 0 ? ' · ' : ''}
                      <a href={l.url}>{l.label}</a>
                    </span>
                  ))}
              </p>
            )}
          </div>
        ))}
      </section>

      <section className="print-section" id="print-notes">
        <h2>Recent notes</h2>
        <p className="eyebrow">Fragments floating around the planet</p>
        {NOTES.map((n) => (
          <div key={n.id} className="note-item">
            <p className="meta">
              {n.date} · {n.tag} · {n.read}
            </p>
            <h3>{n.title}</h3>
            {n.excerpt && <p>{n.excerpt}</p>}
          </div>
        ))}
      </section>

      <section className="print-section" id="print-timeline">
        <h2>Timeline</h2>
        <p className="eyebrow">A glowing path around the planet</p>
        {TIMELINE_MILESTONES.map((m) => (
          <div key={m.year} className="timeline-item">
            <span className="year">{m.year}</span>
            <div>
              <h3>{m.label}</h3>
              {m.story && m.story.map((line, i) => <p key={i}>{line}</p>)}
            </div>
          </div>
        ))}
      </section>

      <section className="print-section" id="print-contact">
        <h2>Contact</h2>
        <p className="eyebrow">Signal tower on the planet</p>
        <div className="contact-card">
          <div className="row">
            <span className="label">Email</span>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          </div>
          <div className="row">
            <span className="label">GitHub</span>
            <a href={CONTACT.github}>Yhazrin</a>
          </div>
          <div className="row">
            <span className="label">Mastodon</span>
            <a href={CONTACT.mastodon}>@yhazrin@hachyderm.io</a>
          </div>
          <div className="row">
            <span className="label">RSS</span>
            <a href={CONTACT.rss}>{CONTACT.rss}</a>
          </div>
        </div>
        <p>{CONTACT.copy}</p>
      </section>
    </div>
  );
}

export default PrintFallback;